import { notesRoute, providerPatientRoute } from '@uplift/constants';
import { BaseNoteActivityItemProps } from './BaseNote.component';
import { Button } from '../../Button';
import { Link } from 'react-router-dom';
import { BaseActivityItem } from '../BaseActivityItem';
import { Typography } from '@mui/material';
import { CommentOutlined } from '@mui/icons-material';


export const DischargeNoteActivityItem: React.FC<BaseNoteActivityItemProps> = props => {
  const params = providerPatientRoute.useParams();

  if (props.note.status === 'incomplete') {
    const button = (
      <Button
        variant="outlined"
        color="secondary"
        component={Link}
        to={notesRoute.createLink({
          noteType: props.noteType,
          noteId: props.note.id,
          patientId: params.patientId
        })}
      >
        Complete Note
      </Button>
    );

    return (
      <BaseActivityItem
        title={<Typography>Discharge Note</Typography>}
        icon={CommentOutlined}
        color="lightBlue"
        rightContent={button}
        children={props.children}
      />
    );
  }

  const reason = props.note.form['reasonForDischarge'];

  return (
    <BaseActivityItem
      onClick={props.onClick}
      title={<Typography>Discharge Note</Typography>}
      icon={CommentOutlined}
      color="lightBlue"
      rightContent={(
        <Typography variant="body2" color="textPrimary">
          with {props.provider.firstName[0]}. {props.provider.lastName}
        </Typography>
      )}
    >
      <Typography color="textSecondary">
        <b>{reason?.label}</b>: {reason?.value}
      </Typography>
    </BaseActivityItem>
  );
};
